import { Custom } from '@clearkit/icons';

import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';

import { HomeHeading } from '../HomeHeading';
import { StepDataMapping, StepSetupForms } from '../HomeNextSteps';

export const HomeSidebarNextSteps = () => {
  const {
    hasEnrichmentFieldMappings,
    hasFormConnectors,
    loading,
  } = useOnboardingStatus();
  const isSectionComplete = hasFormConnectors && hasEnrichmentFieldMappings;

  if (isSectionComplete || loading) return null;

  return (
    <section className="pt-8 space-y-8">
      <HomeHeading>
        <Custom height={16} width={16} /> Next steps with Clearbit
      </HomeHeading>
      {!hasEnrichmentFieldMappings ? <StepDataMapping /> : null}
      {!hasFormConnectors ? <StepSetupForms /> : null}
    </section>
  );
};
